import { axiosInstance } from './config/instance'
import { CONSOLE_API_URL, SERVER } from './config/url'

const EKENG_URL = `${SERVER}/${CONSOLE_API_URL}`
const ENTITY = 'ekeng'

export const ekeng = Object.freeze({
  async fetchSettings() {
    const response = await axiosInstance.get(`${EKENG_URL}/${ENTITY}/settings`)
    return response.data
  },
  async updateSettings(id, data) {
    const response = await axiosInstance.put(`${EKENG_URL}/${ENTITY}/settings/${id}`, data)
    return response.data
  },
})
